<template>
  <div class="bg-white relative" :class="{ 'border-radius shadow p-20 p-10-xs': !single }">
    <div v-if="!single" class="mb-20 flex items-center">
      <button class="btn btn-outline free-width px-15" v-ripple @click="$emit('back')">
        <i class="la la-arrow-left big-text mr-5"></i>
        Back to packages
      </button>

      <div class="flex-1"></div>
      <button class="btn btn-primary free-width px-15" v-ripple @click="open_billing = true">
        <i class="la la-credit-card font-h4 mr-5"></i>
        Billing
      </button>
    </div>

    <!-- SUBSCRIPTION -->
    <div class="div-border border-radius p-20 mb-20">
      <div class="flex">
        <div class="flex-1 pr-20">
          <h5 class="strong mb-5">Subscription</h5>
          <p>This is your current and active subscription on Weezly</p>
        </div>
        <p v-if="billing.subscription" class="mb-0 color-lip pointer" @click="open_cancel_subscription = true">Cancel subscription</p>
      </div>

      <br />

      <!-- monthly/yearly subscription -->
      <div
        v-if="
          [
            'professional_monthly',
            'professional_yearly',
            'professional_trial',
            'business_monthly',
            'business_yearly',
            'business_trial',
            'entry_monthly',
            'entry_trial',
            'growth_monthly',
            'growth_trial',
            'agency_monthly',
            'agency_trial',
          ].includes(me_plan.plan_type)
        "
        class="flex items-center block-xs">
        <img :src="require(`@/assets/img/icons/box-${me_plan.plan_name}.png`)" />
        <div class="flex-1 px-15 px-0-xs">
          <h6 class="strong mb-0 font-h5s color-black capitalize">
            {{ me_plan.plan_name }} <span class="uppercase">({{ me_plan.billed }})</span>
          </h6>
          <h6 class="color-lip" v-if="billing.expiring">
            <em>Your {{ me_plan.plan_name }} tier will expire on {{ moment(billing.expiring.sub_end, "X").format("DD MMMM, YYYY") }}</em>
          </h6>
          <h6 class="color-lip" v-else-if="me.plan_type.endsWith('_trial')">
            <em>Your {{ me_plan.plan_name }} trial will expire on {{ moment(me.trial_end, "X").format("DD MMMM, YYYY") }} </em>
          </h6>
          <h6 v-else-if="me_plan.plan_name == 'professional'" class="color-lightgray mb-0">For individual professionals</h6>
          <h6 v-else-if="me_plan.plan_name == 'business'" class="color-lightgray mb-0">For teams</h6>
          <h6 v-else-if="me_plan.plan_name == 'entry'" class="color-lightgray mb-0">For Email Outreach</h6>
          <h6 v-else-if="me_plan.plan_name == 'growth'" class="color-lightgray mb-0">For Email + Linkedin Outreach</h6>
          <h6 v-else-if="me_plan.plan_name == 'agency'" class="color-lightgray mb-0">Everything included to get your sales</h6>
        </div>
        <div class="nowrap flex items-center align-right" v-if="billing.subscription">
          <div>
            <h2 class="strong mb-0">${{ billing.subscription.price }}</h2>
            <h6 v-if="billing.subscription.plan.billed == 'monthly'">per month</h6>
            <h6 v-else-if="billing.subscription.plan.billed == 'yearly'">per year</h6>
            <div v-if="billing.subscription.coupon" class="color-green">
              You will get
              <span v-if="billing.subscription.coupon.percent_off">{{ billing.subscription.coupon.percent_off }}%</span>
              <span v-else-if="billing.subscription.coupon.amount_off">${{ billing.subscription.coupon.amount_off }}</span>
              off on your subscription
            </div>
          </div>
          <div v-if="billing.subscription.plan_type.startsWith('business_')" class="div-border-left ml-30 pl-30 align-center pr-10">
            <h2 class="strong mb-0">{{ billing.subscription.quantity }}</h2>
            <h6>person</h6>
          </div>
        </div>
      </div>

      <!-- Lifetime deal -->
      <div v-else-if="['lite', 'essential', 'professional'].includes(me.plan_type)" class="flex items-center">
        <img src="@/assets/img/icons/gift-box.png" width="59px" />
        <div class="flex-1 px-15">
          <h6 class="strong mb-0 font-h5s color-black capitalize">{{ me.plan_type }}</h6>
          <h6 class="color-lightgray mb-0">Lifetime</h6>
        </div>
        <div class="nowrap">
          <h4 class="strong mb-0">Lifetime deal</h4>
        </div>
      </div>

      <!-- Free account -->
      <div v-else class="flex items-center">
        <img src="@/assets/img/icons/box-free.png" />
        <div class="flex-1 px-15">
          <h5 class="strong mb-0 font-h5s color-black">Free Plan</h5>
          <h6 class="color-lightgray mb-0">For occasional users and personal use</h6>
        </div>
        <div class="nowrap">
          <h2 class="strong mb-0">$0</h2>
          <h6>per user/month</h6>
        </div>
      </div>
    </div>

    <!-- PAYMENT METHODS -->
    <div class="div-border border-radius p-20 mb-20 p-10-xs">
      <h5 class="strong">Payment method</h5>
      <h6>These are your payments methods added to Weezly and will be used for future payments</h6>
      <div
        v-if="billing.card"
        class="flex block-xs items-center bg-lightblur div-border bg-midnight border-color-lightsteel border-lightblur-darkmode border-radius p-15 font-h6 nowrap">
        <div class="flex items-center">
          <i class="la la-credit-card font-h2"></i>
          <span class="ml-10 mr-20 strong">**** **** **** {{ billing.card.last4 }}</span>
        </div>

        <div class="flex items-center flex-1">
          <span class="mx-20 mx-0-xs">Expires {{ billing.card.exp_month }}/{{ String(billing.card.exp_year).slice(-2) }}</span>
          <div class="flex-1"></div>
          <span>Default</span>
          <Dropdown class="ml-20" :offset="7" ref="ddCard">
            <template slot="toggle">
              <span class="button-round bg-transparent">
                <i class="la la-ellipsis-h font-h3"></i>
              </span>
            </template>
            <template slot="content">
              <div class="btn-selectable pr-20" @click="is_open_add_card = true">Change card</div>
              <div class="btn-selectable danger color-lip pr-20" @click="is_open_remove_card = true">Remove</div>
            </template>
          </Dropdown>
        </div>
      </div>
      <button v-else class="btn btn-primary btn-large mt-20" v-ripple @click="is_open_add_card = true">Add new card</button>

      <!-- Add new card -->
      <Modal
        :value="true"
        v-if="is_open_add_card"
        @close="
          () => {
            if (!is_adding_card) is_open_add_card = false;
          }
        ">
        <template slot="content">
          <div class="relative">
            <Card ref="card" />
            <button class="btn btn-large block btn-primary font-h6 mt-20 uppercase strong" v-ripple @click="addCard">
              <i v-if="is_adding_card" class="la la-spinner spinning big-text mr-5"></i>
              <i v-else class="la la-credit-card big-text mr-5"></i>
              ADD CARD
            </button>
          </div>
        </template>
      </Modal>

      <!-- Remove card -->
      <Modal
        v-if="is_open_remove_card"
        :value="true"
        classContent="bg-danger color-white"
        @close="
          () => {
            if (!is_removing_card) is_open_remove_card = false;
          }
        ">
        <template slot="content">
          <div class="p-10">
            <br />
            <h6 class="color-white align-center">Are you sure to remove this card?</h6>
            <br />
            <div class="flex items-center mt-20">
              <button
                class="btn btn-outline bg-transparent color-white"
                @click="
                  () => {
                    if (!is_removing_card) is_open_remove_card = false;
                  }
                ">
                Cancel
              </button>
              <div class="flex-1"></div>
              <button class="btn btn-outline btn-danger" @click="removeCard">
                <i class="la la-spinner spinning big-text mr-5" v-if="is_removing_card"></i>Remove
              </button>
            </div>
          </div>
        </template>
      </Modal>
    </div>

    <!-- BILLING ADDRESS & TAX -->
    <div class="div-border border-radius p-20 mb-20 p-10-xs">
      <BillingTax />
    </div>

    <!-- BILLING HISTORY -->
    <div class="div-border border-radius p-20">
      <h5 class="strong">Billing history</h5>
      <h6 v-if="billing.invoices.length == 0" class="color-lightgray">You don't have any payments yet</h6>
      <div v-else class="statement-table">
        <div class="row hide-xs">
          <div class="col-30">
            <p>
              <strong>{{ $t("text.date") }}</strong>
            </p>
          </div>
          <div class="col-30">
            <p>
              <strong>{{ $t("text.invoice_number") }}</strong>
            </p>
          </div>
          <div class="col-20">
            <p>
              <strong>{{ $t("text.amount") }}</strong>
            </p>
          </div>
          <div class="col-20"></div>
        </div>

        <div v-for="year in invoices" :key="year.name" class="mb-20">
          <h6 class="color-primary">
            <strong>{{ year.name }}</strong>
          </h6>
          <div class="row pb-10 mb-10 div-border-bottom" v-for="invoice in year.invoices" :key="invoice.id">
            <div class="col-30 full-width-xs">
              <span class="uppercase-first">{{ formatDate(invoice.created) }}</span>
            </div>
            <div class="col-30 full-width-xs flex pointer color-hover-primary">
              <i class="la la-book big-text inline-block mr-5"></i><span class="inline-block">{{ invoice.number }}</span>
            </div>
            <div class="col-20 full-width-xs">${{ invoice.total / 100 }}</div>
            <div class="col-20 full-width-xs color-lightgray uppercase nowrap">
              Download: <a class="color-primary underline strong" target="_blank" :href="invoice.pdf_url">PDF</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING -->
    <div v-if="loading" class="absolute-inside overlay flex items-center">
      <Loading />
    </div>

    <!-- CANCEL SUBSCRIPTION -->
    <CancelSubscription v-if="open_cancel_subscription" :billing="billing" @close="open_cancel_subscription = false" @updated="$emit('updated')" />

    <!-- DOWNGRADE -->
    <Modal v-if="open_downgrade" :value="true" width="720px" @close="downgradeCancel">
      <template slot="content">
        <div class="relative" v-if="!is_downgraded">
          <br /><br />
          <h4 class="strong align-center color-black">
            <span class="capitalize">{{ me.userName }}</span
            >, are you sure you want to <br />
            cancel your subscription?
          </h4>

          <h6 style="line-height: 1.6em" class="align-center">If you cancel your subscription, you will loose access to all features on Weezly.</h6>

          <br />
          <textarea
            class="mt-20"
            :class="{ 'border-color-lip': missing_reason }"
            v-model="reason"
            @input="missing_reason = false"
            ref="reason"
            placeholder="Please tell us the reason why you are downgrading your account, and how can we make things better?"></textarea>

          <div class="mt-30 flex items-center block-xs align-center-xs">
            <div class="flex-1 pr-30 pr-0-xs mb-20-xs">
              <button class="btn free-height block bg-lightblur color-black py-15" v-ripple @click="downgradeMe">
                <span class="font-h6 strong">Yes, cancel</span>
              </button>
            </div>
            <div class="flex-1 pl-30 pl-0-xs">
              <button class="btn free-height block bg-primary color-white py-15" v-ripple @click="downgradeCancel">
                <span class="font-h6 strong">No, keep my subscription 🙏</span>
              </button>
            </div>
          </div>
          <div v-if="downgrading" class="absolute-inside overlay flex items-center">
            <Loading />
          </div>
        </div>
        <div v-else>
          <br /><br />
          <h4 class="strong align-center color-black">
            <span class="capitalize">{{ me.userName }}</span
            >, your subscription <br />
            have been canceled
          </h4>
          <br />
          <h6 style="line-height: 1.8em" class="align-center">
            We are sorry to hear that things didn't work out.
            <br />If you have any suggestions on how we can make things better <br />please contact our support.
          </h6>
          <br /><br />

          <div class="align-center">
            <button class="btn free-height bg-primary color-white py-10 px-30" v-ripple @click="downgradeCancel">
              <span class="font-h5 strong">Continue</span>
            </button>
          </div>
          <br /><br />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import request from "@/service";
import types from "@/constants/types";
import Card from "@/components/Upgrade/Card";
import moment from "moment-timezone";
import BillingTax from "./BillingTax";
import CancelSubscription from "@/components/Setting/CancelSubscription";
export default {
  name: "Billing",
  components: {
    Card,
    BillingTax,
    CancelSubscription,
  },
  props: {
    billing: {
      type: Object,
      default: {
        subscription: false,
        tax: false,
        card: false,
        billing_address: false,
        invoices: [],
        packages: [],
      },
    },
    single: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      is_open_add_card: false,
      is_adding_card: false,

      is_open_remove_card: false,
      is_removing_card: false,

      open_downgrade: false,
      open_cancel_subscription: false,

      missing_reason: false,
      reason: "",
      downgrading: false,
      is_downgraded: false,

      moment: moment,
      loading: false,
    };
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    me_plan() {
      let me = this.me;
      let billed = "";
      if (me.plan_type.endsWith("_monthly")) billed = "Mothly";
      else if (me.plan_type.endsWith("_yearly")) billed = "Yearly";
      else if (me.plan_type.endsWith("_trial")) billed = "Trial";
      return {
        plan_type: me.plan_type,
        quantity: me.quantity,
        plan_name: me.plan_type.replace("_monthly", "").replace("_yearly", "").replace("_trial", ""),
        billed: billed,
      };
    },
    invoices() {
      let data = [];
      for (let i = 0; i < this.billing.invoices.length; i++) {
        const invoice = this.billing.invoices[i];
        let year = moment.unix(invoice.created).format("YYYY");

        let j = 0;
        for (j = 0; j < data.length; j++) {
          const key = data[j].name;
          if (key === year) {
            data[j].invoices.push(invoice);
            break;
          }
        }
        if (j != data.length) continue;
        data.push({ name: year, invoices: [] });
        data[data.length - 1].invoices.push(invoice);
      }
      data.sort((a, b) => parseInt(b.name) - parseInt(a.name));
      return data;
    },
  },
  async mounted() {
    if (this.single) {
      this.loading = true;
      const getData = await request("GET", "stripe/getBilling");
      if (getData) {
        this.billing = getData.data;
        this.loading = false;
      }
    }
  },
  methods: {
    formatDate: (date) => moment.unix(date).format("MMMM DD, YYYY - HH:mm"),
    async addCard() {
      if (this.is_adding_card) return false;

      this.is_adding_card = true;
      const token = await this.$refs.card.createToken();

      if (!token) {
        this.is_adding_card = false;
        return false;
      }

      this.is_adding_card = true;

      let new_payment_method = await request("POST", "stripe/newPaymentMethod", {
        token: token,
      });

      if (!new_payment_method) {
        this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
        this.is_adding_card = false;
        return false;
      }

      new_payment_method = new_payment_method.data;

      let add_payment_method = false;
      if (new_payment_method.status == "created_new_method") {
        add_payment_method = await request("POST", "stripe/addPaymentMethod", {
          method_id: new_payment_method.method_id,
        });
      } else if (new_payment_method.status == "need_confirm_payment_intent") {
        const confirm_intent = await this.$stripe.confirmCardPayment(new_payment_method.client_secret, {
          setup_future_usage: "off_session",
        });
        console.log(confirm_intent);
        if (confirm_intent.paymentIntent && confirm_intent.paymentIntent.status == "requires_capture") {
          add_payment_method = await request("POST", "stripe/addPaymentMethod", {
            method_id: confirm_intent.paymentIntent.payment_method,
            intent_id: confirm_intent.paymentIntent.id,
          });
        }
      }

      this.is_adding_card = false;

      if (!add_payment_method) {
        this.$root.$emit("alert", "Can not confirm your card!", "error");
      } else {
        this.$root.$emit("alert", "Your new card has been updated!");
        this.$emit("updated");
        this.is_open_add_card = false;
      }
    },
    async removeCard() {
      if (this.is_removing_card) return false;

      this.is_removing_card = true;

      const responsePayment = await request("POST", "stripe/removePaymentMethod");

      if (responsePayment) {
        this.$root.$emit("alert", "Your card has been removed!");
        this.$emit("updated");
        this.is_open_remove_card = false;
      } else {
        this.$root.$emit("alert", this.$t("upgrade.something_wrong"), "error");
      }

      this.is_removing_card = false;
    },

    downgradeCancel() {
      if (this.downgrading) return false;
      this.open_downgrade = false;
    },
    async downgradeMe() {
      let reason = this.reason.trim();
      if (reason == "") {
        this.$refs.reason.focus();
        this.missing_reason = true;
        return false;
      }

      this.downgrading = true;
      const unsubscribe = await request("POST", "stripe/unsubscribe", {
        reason: reason,
      });

      if (unsubscribe) {
        this.$emit("updated");
        this.is_downgraded = true;
        await this.$store.dispatch({
          type: types.getMeInfo,
        });
      } else {
        this.$root.$emit("alert", this.$t("alert.something_wrong"), "error");
      }
      this.downgrading = false;
    },
  },
};
</script>
